<template>
  <div class="ipo-detail-grid">
    <div class="ipo-detail-card">
      <div class="ipo-detail-label">
        {{ selectedIpo.type != 3 ? $t('ipo.unit_price_stock') : $t('ipo.unit_price_bond') }}
      </div>
      <div class="ipo-detail-value">{{ moneyFmt(selectedIpo.detail.unit_price) }}</div>
    </div>
    <div class="ipo-detail-card">
      <div class="ipo-detail-label">{{ $t('ipo.collection_amount') }}</div>
      <div class="ipo-detail-value">{{ moneyFmt(selectedIpo.detail.collection_amount) }}</div>
    </div>
    <div v-if="selectedIpo.type != 3" class="ipo-detail-card">
      <div class="ipo-detail-label">{{ $t('ipo.public_offering') }}</div>
      <div class="ipo-detail-value">
        {{ numFmt(selectedIpo.detail.suggested_share) }}{{ $t('ipo.qty') }} —
        {{ numFmt(selectedIpo.detail.suggested_percent) }}%
      </div>
    </div>
    <div v-else class="ipo-detail-card">
      <div class="ipo-detail-label">{{ $t('ipo.auction_time') }}</div>
      <div class="ipo-detail-value">{{ selectedIpo.auction_time }}</div>
    </div>
    <ipo-progress v-if="selectedIpo.type != 3" :symbol="selectedIpo.symbol" />
    <div v-else class="ipo-detail-card">
      <div class="ipo-detail-label">{{ $t('ipo.frequency') }}</div>
      <div class="ipo-detail-value">{{ $t('ipo.frequency_names.' + selectedIpo.brand_bond.frequency) }}</div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import IpoProgress from './IpoProgress.vue'

export default {
  name: 'IpoDetail',
  components: { IpoProgress },
  computed: {
    ...mapGetters('ipoOrder', ['selectedIpo']),
  },
  methods: {
    moneyFmt(val) {
      if (!this.selectedIpo?.currency_code || this.selectedIpo.currency_code === 'MNT')
        return '₮ ' + new Intl.NumberFormat().format(val ?? 0)
      return new Intl.NumberFormat('mn-MN', {
        style: 'currency',
        currency: this.selectedIpo.currency_code,
      }).format(val ?? 0)
    },
    numFmt(val) {
      return new Intl.NumberFormat().format(val ?? 0)
    },
  },
}
</script>
